var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('router-view'),_c('nprogress-container'),_c('ImageFilter'),_c('LoadingOverlay',{attrs:{"active":_vm.loadingOverlay,"is-full-page":true},on:{"update:active":function($event){_vm.loadingOverlay=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }